import api from "./api";

/**
 * Uploads an image to the server.
 *
 * @param {Object} file - The image file to be uploaded.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const uploadBanner = async (file) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/upload/banner`;

  const formData = new FormData();
  formData.append('image', file);

  try {
    const response = await api.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
}

export default uploadBanner;
